import debug from 'bows/dist/bows.min.js';
const log = debug("email-capture");

const gformEmailForm = document.querySelector('.gform-email-capture');
const gformEmailInput = document.querySelector('.gform-email-input');
let gformEmailSubmit = '';

if (gformEmailForm) {
	gformEmailSubmit = gformEmailForm.querySelector('.gform_button');
}

export function init() {
	if (gformEmailInput && gformEmailSubmit) {
		gformEmailInput.append(gformEmailSubmit);
	}

}
export default {
	init
};
